import axios from "axios";
import config from "../config";
const endPoint = "/shipping/service/v1";

class DeliveryMethodService {
	async list(checkoutId) {
		const response = await axios.post(`${endPoint}/rates/checkout`, {
			checkoutId,
		});
		const { data } = response;
		return data;
	}
}

export default new DeliveryMethodService();
